import { useState, useEffect } from 'react'
import { shouldRestrictAccess, getDeviceType, type DeviceType } from '../utils/deviceUtils'

interface DeviceDetection {
  deviceType: DeviceType
  isMobileOrTablet: boolean
  isDesktop: boolean
  shouldRestrict: boolean
}

export const useDeviceDetection = (): DeviceDetection => {
  const [deviceInfo, setDeviceInfo] = useState<DeviceDetection>(() => ({
    deviceType: getDeviceType(),
    isMobileOrTablet: shouldRestrictAccess(),
    isDesktop: !shouldRestrictAccess(),
    shouldRestrict: shouldRestrictAccess()
  }))

  useEffect(() => {
    const handleResize = () => {
      const newDeviceType = getDeviceType()
      const newShouldRestrict = shouldRestrictAccess()
      
      setDeviceInfo({
        deviceType: newDeviceType,
        isMobileOrTablet: newShouldRestrict,
        isDesktop: !newShouldRestrict,
        shouldRestrict: newShouldRestrict
      })
    }

    window.addEventListener('resize', handleResize)
    
    // Initial check on mount
    handleResize()

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return deviceInfo
}